import React, { useState, useEffect } from 'react';
import './SeedsActionPopup.css';
import { API_URL } from '../config';

const SeedsActionPopup = ({ isOpen, onClose, onSubmit, seedsName, bagNumber, seedsID, actionType, existingData }) => {
  const [formActionType, setFormActionType] = useState(actionType || '');
  const [formData, setFormData] = useState({
    weight: '',
    startDateTime: '',
    infestationRate: '',
    room: '',
    startDate: '',
    lastGermTestDate: '',
    germinationPercentage: '',
  });
  const [isBackToStock, setIsBackToStock] = useState(false);
  const [returnedWeight, setReturnedWeight] = useState('');
  const [newGerminationRate, setNewGerminationRate] = useState('');

  useEffect(() => {
    if (existingData) {
      console.log('Existing Data:', existingData); // Debug log
      setFormData({
        weight: existingData.Weight || '',
        startDateTime: existingData.StartDateTime || '',
        infestationRate: existingData.InfestationRate || '',
        room: existingData.Room || '',
        startDate: existingData.StartDate ? existingData.StartDate.split('T')[0] : '',
        lastGermTestDate: existingData.LastGermTestDate || '',
        germinationPercentage: existingData.GerminationPercentage || '',
      });
      setIsBackToStock(false);
      setReturnedWeight('');
      setNewGerminationRate('');
    } else {
      setFormData({
        weight: '',
        startDateTime: '',
        infestationRate: '',
        room: '',
        startDate: '',
        lastGermTestDate: '',
        germinationPercentage: '',
      });
      setIsBackToStock(false);
      setReturnedWeight('');
      setNewGerminationRate('');
    }
  }, [existingData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleSubmit = (e) => {
  e.preventDefault();
  console.log('Submitting data:', {
    existingData,
    formActionType,
    isBackToStock,
    returnedWeight,
    newGerminationRate,
    formData,
  });
  if (existingData && isBackToStock) {
    const completionData = {
      id: existingData.TreatmentID || existingData.GerminationID,
      ...(formActionType === 'treatment' && { returnedWeight }),
      ...(formActionType === 'germination' && { germinationPercentage: newGerminationRate }),
    };
    console.log('Submitting completionData:', completionData);
    onSubmit(completionData, `${API_URL}/api/${formActionType === 'treatment' ? 'seeds_treatment' : 'seedsgermination'}/${existingData.TreatmentID || existingData.GerminationID}`);
  } else if (formActionType) {
    const dataToSubmit = {
      seedsID,
      bagNumber,
      actionType: formActionType,
      ...formData,
    };
    console.log('Submitting new action:', dataToSubmit);
    onSubmit(dataToSubmit, `${API_URL}/api/${formActionType === 'treatment' ? 'seeds_treatment' : 'seedsgermination'}`);
  }
};
  if (!isOpen) return null;

  return (
    <div className="seeds-action-popup-overlay">
      <div className="seeds-action-popup-content">
        <div className="seeds-action-popup-header">
          <h2>{seedsName} - Bag {bagNumber}</h2>
          <button className="seeds-action-popup-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          {existingData ? (
            <>
              <div className="seeds-action-popup-field">
                <label>Action Type</label>
                <input type="text" value={formActionType} readOnly />
              </div>
              {formActionType === 'treatment' && (
                <>
                  <div className="seeds-action-popup-field">
                    <label>Weight (lb)</label>
                    <input type="text" name="weight" value={formData.weight} readOnly />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Start Date and Time</label>
                    <input type="text" name="startDateTime" value={formData.startDateTime} readOnly />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Infestation Rate</label>
                    <input type="text" name="infestationRate" value={formData.infestationRate} readOnly />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Room</label>
                    <input type="text" name="room" value={formData.room} readOnly />
                  </div>
                </>
              )}
              {formActionType === 'germination' && (
                <>
                  <div className="seeds-action-popup-field">
                    <label>Weight (lb)</label>
                    <input type="text" name="weight" value={formData.weight} readOnly />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Start Date</label>
                    <input type="text" name="startDate" value={formData.startDate} readOnly />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Last Germination Test Date</label>
                    <input type="text" name="lastGermTestDate" value={formData.lastGermTestDate} readOnly />
                  </div>
                </>
              )}
              <div className="seeds-action-popup-field back-to-stock-field">
                <label>
                  <input
                    type="checkbox"
                    checked={isBackToStock}
                    onChange={(e) => setIsBackToStock(e.target.checked)}
                  />
                  Back to Stock
                </label>
              </div>
              {isBackToStock && formActionType === 'treatment' && (
                <div className="seeds-action-popup-field">
                  <label>Returned Weight (lb)</label>
                  <input
                    type="number"
                    name="returnedWeight"
                    value={returnedWeight}
                    onChange={(e) => setReturnedWeight(e.target.value)}
                    step="0.01"
                    min="0"
                    required
                  />
                </div>
              )}
              {isBackToStock && formActionType === 'germination' && (
                <div className="seeds-action-popup-field">
                  <label>New Germination Rate (%)</label>
                  <input
                    type="number"
                    name="newGerminationRate"
                    value={newGerminationRate}
                    onChange={(e) => setNewGerminationRate(e.target.value)}
                    step="0.01"
                    min="0"
                    max="100"
                    required
                  />
                </div>
              )}
            </>
          ) : (
            <>
              <div className="seeds-action-popup-field">
                <label>Action</label>
                <select
                  value={formActionType}
                  onChange={(e) => setFormActionType(e.target.value)}
                  required
                >
                  <option value="">Select an action</option>
                  <option value="treatment">Treatment</option>
                  <option value="germination">Germination Test</option>
                </select>
              </div>
              {formActionType === 'treatment' && (
                <>
                  <div className="seeds-action-popup-field">
                    <label>Weight (lb)</label>
                    <input
                      type="number"
                      name="weight"
                      value={formData.weight}
                      onChange={handleInputChange}
                      step="0.01"
                      min="0"
                      required
                    />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Start Date and Time</label>
                    <input
                      type="datetime-local"
                      name="startDateTime"
                      value={formData.startDateTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Infestation Rate</label>
                    <select
                      name="infestationRate"
                      value={formData.infestationRate}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select rate</option>
                      <option value="Heavy">Heavy</option>
                      <option value="Moderate">Moderate</option>
                      <option value="Light">Light</option>
                    </select>
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Room</label>
                    <select
                      name="room"
                      value={formData.room}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select room</option>
                      <option value="Heavy">Heavy</option>
                      <option value="Light">Light</option>
                    </select>
                  </div>
                </>
              )}
              {formActionType === 'germination' && (
                <>
                  <div className="seeds-action-popup-field">
                    <label>Weight (lb)</label>
                    <input
                      type="number"
                      name="weight"
                      value={formData.weight}
                      onChange={handleInputChange}
                      step="0.01"
                      min="0"
                      required
                    />
                  </div>
                  <div className="seeds-action-popup-field">
                    <label>Start Date</label>
                    <input
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </>
              )}
            </>
          )}
          <div className="seeds-action-popup-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={!formActionType}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SeedsActionPopup;